
























import { Component, Vue, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import { roleManage } from '../role';

type ICreateRoleOrUpdateParams = IRole.IRequest.ICreateRoleOrUpdateParams;

interface IForm {
  name: string;
  comment: string;
  active: boolean;
}


@Component
export default class RoleForm extends Vue {
  @Ref() private readonly editRoleForm!: FormModel;
  private loading = false;
  private rules = {
    name: [{ required: true, message: () => this.$t('form.required'), trigger: 'blur'}],
  };
  private form: IForm = {
    name: '',
    comment: '',
    active: true,
  };
  private created() {
    this.readyFormData();
  }
  private readyFormData() {
    if (!roleManage.editData.roleInfo) {
      return;
    }
    const { name, comment, active } = roleManage.editData.roleInfo!;
    this.form = {
      name,
      comment,
      active,
    };
  }
  private handleSubmit() {
    this.editRoleForm.validate((valid) => {
      if (valid) {
        const {name, comment, active} = this.form;
        const params: ICreateRoleOrUpdateParams = {
          name,
          comment,
          active,
        };
        this.submitUpdateRole(params);
      } else {
        return false;
      }
    });
  }
  private submitUpdateRole(params: ICreateRoleOrUpdateParams) {
    this.loading = true;
    roleManage.requestUpdateRole(params).then((res) => {
      this.loading = false;
      this.$message.success(res);
      this.endEdit();
    }).catch((err) => {
      this.loading = false;
      this.$message.warning(err);
    });
  }
  private endEdit() {
    this.$emit('ok');
  }
}
